import { render, staticRenderFns } from "./SalarySampleCreate.vue?vue&type=template&id=09dbdd06&scoped=true"
import script from "./SalarySampleCreate.vue?vue&type=script&lang=js"
export * from "./SalarySampleCreate.vue?vue&type=script&lang=js"
import style0 from "./SalarySampleCreate.vue?vue&type=style&index=0&id=09dbdd06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dbdd06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09dbdd06')) {
      api.createRecord('09dbdd06', component.options)
    } else {
      api.reload('09dbdd06', component.options)
    }
    module.hot.accept("./SalarySampleCreate.vue?vue&type=template&id=09dbdd06&scoped=true", function () {
      api.rerender('09dbdd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalarySampleCreate.vue"
export default component.exports